import type { Message } from './types'

let tempMessageCounter = -1

export function createTempMessageId(): number {
  tempMessageCounter -= 1
  return tempMessageCounter
}

export function createOptimisticMessage(params: {
  tempId: number
  content: string
  authorId: number
  authorName: string
  chatId?: number
}): Message {
  return {
    id: params.tempId,
    content: params.content,
    type: 'text',
    author: {
      id: params.authorId,
      name: params.authorName,
    },
    attachments: [],
    created_at: new Date().toISOString(),
    ...(params.chatId !== undefined ? { chat_id: params.chatId } : {}),
  }
}

export function appendOptimisticMessage(messages: Message[], optimistic: Message): Message[] {
  return [...messages, optimistic]
}

export function rollbackOptimisticMessage(messages: Message[], tempId: number): Message[] {
  return messages.filter((message) => message.id !== tempId)
}

export function replaceOptimisticMessage(
  messages: Message[],
  tempId: number,
  confirmed: Message,
): Message[] {
  // Если Mercure уже добавил confirmed.id, только снять tempId
  if (messages.some((message) => message.id === confirmed.id)) {
    return messages.filter((message) => message.id !== tempId)
  }

  const index = messages.findIndex((message) => message.id === tempId)
  if (index === -1) {
    return [...messages, confirmed]
  }

  const updated = [...messages]
  updated[index] = confirmed
  return updated
}
